import { useEffect, useMemo, useState } from "react"
// import useModelsStore from "../../stores/models"
import styles from "./ListItem.module.scss"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBagShopping, faMemoCircleInfo, faPartyHorn, faStopwatch } from "@fortawesome/pro-regular-svg-icons"
import { faStars } from "@fortawesome/pro-solid-svg-icons"
import useTranslation from "../../Hooks/useTranslation"
import useHelpers from "../../Hooks/useHelpers"
import useTarifs from "../../Hooks/useTarifs"
import useCollections from "../../Hooks/useCollections"
import DynImage from "../DynImage"
import usePrefStore from "../../stores/prefs"
// import useTest from "../../Hooks/useTest"

function capitalize(str) {
   if (!str) return '';
   return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function ListItem(props) {
   // const showCess = usePrefStore((state) => state.showCess)
   const { showCess } = usePrefStore()
   //
   // const models = useModelsStore((state) => state.models)
   const [model, setModel] = useState(null)
   const { trans } = useTranslation()
   // const { test } = useTest()
   const { formatWeightWithNC, formatDiamWeightWithNC, formatNumberWithNC, formatPPUPrice, formatCESPrice } = useHelpers()
   const { getMinMaxPriceForModel, getMinMaxCessPriceForModel, getColorsForModel } = useTarifs()
   const [minMax, setMinMax] = useState({ min: 0, max: 0 })
   const [minMaxCession, setMinMaxCession] = useState({ min: 0, max: 0 })
   const [porte, setPorte] = useState('')
   const [cycle, setCycle] = useState('')
   const [argu, setArgu] = useState(null)
   const [/*gamme*/, setGamme] = useState('')
   const [collection, setCollection] = useState('')
   const [sousCollection, setSousCollection] = useState('')
   const { getModelById, getPorteById, getGammeById, getCollectionById, getSousCollectionById, getCycleById, isHJOModel, isFJOModel, getUniversById, isExcluBoutique } = useCollections()
   const [strColors, setStrColors] = useState('')
   const [modelImage, setModelImage] = useState(null)
   const [isHJO, setIsHJO] = useState(false)
   const [isFJO, setIsFJO] = useState(false)

   useEffect(() => {
      const a_model = getModelById(props.id)
      const ret_colors = getColorsForModel(a_model.id)

      setModel(a_model)
      setGamme(getGammeById(a_model.gamme).label)
      setCollection(getCollectionById(a_model.collec).label)
      setSousCollection(getSousCollectionById(a_model.sous_collec).label)
      setPorte(getPorteById(a_model.porte).label)
      setCycle(getCycleById(a_model.cycle).label)
      // console.log('+++MODEL', a_model);
      // console.log('+++MODEL2', a_model.argu);
      if (isExcluBoutique(a_model)) {
         // console.log('+++MODEL3');
         // setArgu(trans('?Exclu boutique'))
         setArgu(<FontAwesomeIcon icon={faStars} />)
      } else {
         // console.log('+++MODEL4');
         setArgu(null)
      }
      setStrColors(ret_colors?.colors?.join(", "))
      setIsHJO(isHJOModel(props.id))
      setIsFJO(isFJOModel(props.id))
   }, [getCollectionById, getColorsForModel, getCycleById, getGammeById, getModelById, getPorteById, getSousCollectionById, isExcluBoutique, isFJOModel, isHJOModel, props])

   // useEffect(() => {
   //    console.log('MM** ICI2');
   //    let minmax = getMinMaxPriceForModel(model?.id)
   //    if (!minmax.reason) {   // reason contient un texte d'erreur si pb
   //       setMinMax(minmax)
   //    } else {
   //       setMinMax({ min: 0, max: 0 })
   //    }
   //    minmax = getMinMaxCessPriceForModel(model?.id)
   //    if (!minmax.reason) {   // reason contient un texte d'erreur si pb
   //       setMinMaxCession(minmax)
   //    } else {
   //       setMinMaxCession({ min: 0, max: 0 })
   //    }
   // }, [setMinMax, setMinMaxCession, getMinMaxPriceForModel, getMinMaxCessPriceForModel, model])

   const min_max = useMemo(() => {
      if (model) {
         const minmax = getMinMaxPriceForModel(model?.id)
         if (!minmax.reason) {   // reason contient un texte d'erreur si pb
            return minmax
         } else {
            return { min: 0, max: 0 }
         }
      } else {
         return { min: 0, max: 0 }
      }
   }, [getMinMaxPriceForModel, model])

   // console.log('MM** ICI');
   // console.log('min_max', min_max);

   const min_max_cess = useMemo(() => {
      if (model) {
         const minmax = getMinMaxCessPriceForModel(model?.id)
         if (!minmax.reason) {   // reason contient un texte d'erreur si pb
            return minmax
         } else {
            return { min: 0, max: 0 }
         }
      } else {
         return { min: 0, max: 0 }
      }
   }, [getMinMaxCessPriceForModel, model])

   useEffect(() => {
      setMinMax(min_max)
      setMinMaxCession(min_max_cess)
   }, [min_max, min_max_cess])

   function showQtyPicker() {
      if (props.onShowQtyPicker) {
         props.onShowQtyPicker(props.id)
      }
   }

   function showDetail() {
      if (props.onShowDetail) {
         props.onShowDetail(props.id)
      }
   }

   useEffect(() => {
      if (model && model.id) {
         setModelImage(<DynImage className={styles.imgmodel} src={[`catalogue/modeles/${model.id}@2x.png`, model.bymessika ? model.bymessika[0] : null]} alt={`Model ${model.id}`} />)
      }
   }, [model])

   return (model &&
      <div className="flex gap-4 font-bold text-sm p-4 my-1 bg-white rounded-lg flex-row">
         {/* <img src={`catalogue/modeles/${model.id}@2x.png`} alt={`Model ${model.id}`} /> */}
         {modelImage}
         <div className="flex flex-col items-start abg-red-100 gap-2">
            <div className="flex flex-row items-end gap-3">
               <div className="flex flex-col text-xs leading-tight">
                  {model.univers && <div className="border-ome-brown-primary text-black rounded-t-md border-solid border-b-0 py-1 px-2 min-h-6">{getUniversById(model.univers).label}</div>}
                  {!model.univers && <div className="border-ome-brown-primary text-gray-400 italic font-normal rounded-t-md border-solid py-1 px-2 min-h-6">Sans univers</div>}
                  <span className="bg-ome-brown-primary text-white rounded-b-md text-xs py-1 px-2">{collection}{sousCollection ? ` / ${sousCollection}` : ""}</span>
               </div>
               <div className="h-1/2 flex flex-row gap-4 align-middle justify-center">
                  <span className="text-xl font-extrabold truncate inline-flex items-center">
                     {props.id} - {model.label || ''}
                     <span className="mt-[-5px] px-3 text-lg text-ome-red-primary">{argu}</span>
                  </span>
                  <span className="justify-center self-center flex gap-2">
                     <span className="text-xs border-[1px] rounded-md border-solid py-1 px-2 inline-flex items-center">{cycle}</span>
                     {model.tps_fort && <span className="text-xs border-[1px] rounded-md border-solid py-1 px-2 flex gap-1 items-center">
                        <FontAwesomeIcon icon={faPartyHorn} />{model.tps_fort}
                     </span>}
                     {model.event && <span className="text-xs border-[1px] rounded-md border-solid py-1 px-2 flex gap-1 items-center"><FontAwesomeIcon icon={faStopwatch} />{model.event}</span>}
                  </span>
               </div>
            </div>
            <span className="text-xs font-semibold text-ome-gray-40">
               {model.desig || ''}
            </span>
            <span className="text-md+">{porte}{model.type_bo ? ` - ${capitalize(model.type_bo)}` : ""}</span>
            <table className="border-collapse mt-4">
               <thead className="mb-[50px]">
                  <tr className="uppercase text-xs text-ome-gray-40 text-left pb-[50px]">
                     <th className="border-0 border-r-[1px] border-solid border-ome-border-light pr-5 pb-1 align-top">{trans("?Couleur")}</th>
                     <th className="border-0 border-r-[1px] border-solid border-ome-border-light pr-5 pl-2 align-top">{trans("?Poids")}</th>
                     <th className="border-0 border-r-[1px] border-solid border-ome-border-light pr-5 pl-2 align-top">{trans("?Poids diamants")}</th>
                     <th className="border-0 border-r-[1px] border-solid border-ome-border-light pr-5 pl-2 align-top">{trans("?Diamants")}</th>
                     <th className="pr-5 pl-2 align-top">{trans("?Ecrin")}</th>
                  </tr>
               </thead>
               <tbody>
                  <tr>
                     <td className=" border-ome-border-light border-0 border-r-[1px] border-solid pr-5">{strColors}</td>
                     <td className=" border-ome-border-light border-0 border-r-[1px] border-solid pr-5 pl-2">{`${formatWeightWithNC(model.pds)}`}</td>
                     <td className=" border-ome-border-light border-0 border-r-[1px] border-solid pr-5 pl-2">{`${formatDiamWeightWithNC(model.pdsdts)}`}</td>
                     <td className=" border-ome-border-light border-0 border-r-[1px] border-solid pr-5 pl-2">{`${formatNumberWithNC(model.dts)}`}</td>
                     <td className="pr-5 pl-2">{model.ecrin}</td>
                  </tr>
               </tbody>
            </table>
         </div>
         <div className="ml-auto shrink-0 flex flex-col items-end">
            <span className="font-bold text-xl text-ome-red-primary">{isHJOModel(props.id) ? trans("?Sur commande/Devis") : formatPPUPrice(minMax.min)}</span>
            {!isHJOModel(props.id) && showCess && <span className="font-bold text-ome-gray-50 text-xs">{trans("?Cess.")} : {formatCESPrice(minMaxCession.min)}</span>}
            {model.param_comm && <span className="font-bold text-ome-gray-50 text-xs">{model.param_comm}</span>}
            <div className="mt-auto gap-1 flex">
               <button className="border-none cursor-pointer text-2xl bg-transparent" onClick={showDetail}><FontAwesomeIcon icon={faMemoCircleInfo} /></button>
               {(isHJO || isFJO) &&
                  <button className="border-none bg-transparent text-2xl text-ome-gray-20 cursor-[inherit]"><FontAwesomeIcon icon={faBagShopping} /></button>
               }
               {!isHJO && !isFJO &&
                  <button className="border-none cursor-pointer text-2xl bg-transparent" onClick={showQtyPicker}><FontAwesomeIcon icon={faBagShopping} /></button>
               }
            </div>
         </div>
      </div>
   )
}

export default ListItem
